import { useEffect } from "react";

import * as S from "./styles";

// Modal genérico de visualização (somente leitura) para telas admin. O
// `Modals/Confirm` existente é o confirm GLOBAL (montado no App.jsx via
// UseGlobalConfirm) e não serve para exibir conteúdo.
const Preview = ({ open, title, onClose, children }) => {
  // Fechar com ESC — o conteúdo pode ser alto e o botão sair de vista.
  useEffect(() => {
    if (!open) return;

    const onKeyDown = (event) => {
      if (event.key === "Escape") onClose?.();
    };

    window.addEventListener("keydown", onKeyDown);

    return () => window.removeEventListener("keydown", onKeyDown);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <S.Modal open={open}>
      <S.Background onClick={onClose} />
      <S.ModalWrapper>
        <S.Header>
          <S.Title>{title}</S.Title>
          <S.Close type="button" onClick={onClose} aria-label="Fechar">
            ✕
          </S.Close>
        </S.Header>
        <S.Content>{children}</S.Content>
      </S.ModalWrapper>
    </S.Modal>
  );
};

export default Preview;
